module.exports = __webpack_public_path__ + "static/img/bz.64d617ea.svg";